import moment from "moment";
export class Termo {
  constructor({
    id = null,
    nome = null,
    tipo = null,
    dataInicio = null,
    dataFim = null,
    conteudo = null,
    acao = {},
  }) {
    this.id = id;
    this.nome = nome;
    this.dataInicio = dataInicio;
    this.dataFim = dataFim;
    this.conteudo = conteudo;
    this.tipo = tipo;
    this.acao = acao;
  }
  static Build() {
    return new Termo({
      id: null,
      nome: null,
      dataInicio: null,
      dataFim: null,
      conteudo: null,
      tipo: null,
      acao: {},
    });
  }
  format() {
    this.dataInicio = moment(this.dataInicio).format('YYYY-MM-DD');
    this.dataFim = moment(this.dataFim).format('YYYY-MM-DD');
    return this;
  }
}